var React = require('react');

function Door (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.6665","y":"0.898438","width":"7.11111","height":"14.2222","fill":"currentColor","fillOpacity":"0.3","key":0}),React.createElement("path",{"d":"M0 16.0098V14.6764H2.04444V0.00976562H10.7111V1.00977H13.9778V14.6764H16V16.0098H12.6444V2.3431H10.7111V16.0098H0ZM7.35556 8.89865C7.60889 8.89865 7.81778 8.81421 7.98667 8.64088C8.15556 8.47199 8.24 8.25865 8.24444 8.00977C8.24444 7.75643 8.16 7.54754 7.98667 7.37865C7.81778 7.20977 7.60444 7.12088 7.35556 7.12088C7.10667 7.12088 6.89333 7.20532 6.72444 7.37865C6.55556 7.54754 6.46667 7.76088 6.46667 8.00977C6.46667 8.25865 6.55111 8.47199 6.72444 8.64088C6.89333 8.80977 7.10667 8.89865 7.35556 8.89865ZM3.37778 14.6764H9.37778V1.3431H3.37778V14.6764Z","fill":"currentColor","key":1})]);
}

Door.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Door;

Door.default = Door;
